import { useMutation } from "@apollo/client/react";
import { useCallback } from "react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import {
  AzureDevOpsRepoIntegration,
  MutationAzureDevOpsRepoIntegrationCreateArgs,
} from "types/generated";
import useAnalytics from "hooks/useAnalytics";
import { AnalyticsPageVCS } from "hooks/useAnalytics/pages/vcs";

import { CREATE_AZURE_DEVOPS_INTEGRATION } from "./gql";

const useCreateAzureDevOpsIntegration = () => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const trackSegmentAnalyticsEvent = useAnalytics({
    page: AnalyticsPageVCS.VCSIntegrations,
  });

  const [azureDevOpsRepoIntegrationCreate, { loading }] = useMutation<{
    azureDevOpsRepoIntegrationCreate: AzureDevOpsRepoIntegration;
  }>(CREATE_AZURE_DEVOPS_INTEGRATION);

  const createAzureDevOpsIntegration = useCallback(
    (input: MutationAzureDevOpsRepoIntegrationCreateArgs, successCallback?: () => void) => {
      azureDevOpsRepoIntegrationCreate({
        variables: input,
      })
        .then(({ data }) => {
          if (data?.azureDevOpsRepoIntegrationCreate) {
            reportSuccess({
              message: `Integration ${data.azureDevOpsRepoIntegrationCreate.name} was successfully created`,
            });
            successCallback?.();

            trackSegmentAnalyticsEvent("Azure DevOps - Setup Finished", {
              labels: input.customInput?.labels?.length,
              space: input.customInput?.spaceID,
            });
          }
        })
        .catch(onError);
    },
    [azureDevOpsRepoIntegrationCreate, onError, reportSuccess, trackSegmentAnalyticsEvent]
  );

  return {
    createAzureDevOpsIntegration,
    loading,
  };
};

export default useCreateAzureDevOpsIntegration;
